import { BaseApiClient } from './base-client'
import { API_ROUTES, interpolateRoute } from '@super/shared-types'
import type {
  Scratchpad,
  ScratchpadMentionedDelta,
  EventLogEntry,
} from '@super/shared-types'

export interface SessionScratchpad {
  initial: Scratchpad | null
  mentioned: ScratchpadMentionedDelta | null
  eventLog: EventLogEntry[]
  contextPrompt: string | null
  intakeLog: string[] | null
}

class ScratchpadApiClient extends BaseApiClient {
  async getBySession(sessionId: string): Promise<SessionScratchpad> {
    const path = interpolateRoute(API_ROUTES.ADMIN.SCRATCHPAD.BY_SESSION, {
      sessionId,
    })
    const res = await this.request<{ data: SessionScratchpad }>(path)
    return res.data
  }
}

export const scratchpadClient = new ScratchpadApiClient()
